const styles = {
  errorMessage: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "296px",
    fontFamily: "Roboto",
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0.1px",
    color: "#818C99",
    fontWeight: "400",
    marginTop: "172px",
    textAlign: "center",
  },
  refreshButton: {
    background: "#fff",
    border: "1px solid #06844D",
    width: "87vw",
    marginLeft: "6.5vw",
    height: "44px",
    position: "fixed",
    bottom: "23px",
    left: 0,
    zIndex: 2,
    color: "#06844D",
  },
};

export default styles;
